import { render, staticRenderFns } from "./MarketingEmail.vue?vue&type=template&id=1ff2c996&scoped=true"
import script from "./MarketingEmail.vue?vue&type=script&lang=js"
export * from "./MarketingEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2c996",
  null
  
)

export default component.exports